import { styled } from '@mui/material';

export const Root = styled('div')(() => ({
  width: '100%',
  overflow: 'hidden',
}));

// TODO: remove this commented code if not needed
// export const StyledEditable = styled(Editable)(({ theme }) => ({
//   height: '100%',
//   overflow: 'auto',
// })) as typeof Editable;
